var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRedNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.012,
    height: 41.012,
    viewBox: "0 0 41.012 41.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_request",
    fill: "#d50007",
    "data-name": "add request",
    transform: "rotate(-45 471.817 1731.433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    "data-name": "Ellipse 62",
    opacity: 0.143,
    transform: "translate(1348 188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    d: "M30.23 977.362a1.046 1.046 0 0 0-1.046 1.046v3.138h-3.138a1.046 1.046 0 0 0 0 2.092h3.138v3.138a1.046 1.046 0 0 0 2.092 0v-3.138h3.138a1.046 1.046 0 0 0 0-2.092h-3.138v-3.138a1.046 1.046 0 0 0-1.046-1.046z",
    "data-name": "Path 471",
    transform: "translate(1332.534 -779.828)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedNew);
export default __webpack_public_path__ + "static/media/closeRedNew.1154c7b29650bd286cdeb9e6d4a6673a.svg";
export { ForwardRef as ReactComponent };